module.exports = __webpack_public_path__ + "img/icon-renegades-le_woodsy.ea724f4.png";